module.exports = __webpack_public_path__ + "img/LV.a1451f8c.png";